import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { LocaleProvider } from 'antd';
import { createBrowserHistory } from 'history';
import { ThemeProvider } from 'styled-components';
import moment from 'moment-timezone';
import locales from 'antd/lib/locale-provider/en_US';

import createStore from 'utils/createStore';

import theme from './theme';
import App from './App';
import './index.css';

moment.tz.setDefault('Asia/Bangkok');

const rootElement = document.getElementById('root');

const history = createBrowserHistory()
const store = createStore(history);

const EntryComponent = Comp => (
  <LocaleProvider locale={locales}>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <Comp />
        </ConnectedRouter>
      </Provider>
    </ThemeProvider>
  </LocaleProvider>
);

ReactDOM.render(
  EntryComponent(App),
  rootElement,
);

if (module.hot) {
  module.hot.accept('./App', () => {
    const NextApp = require('./App').default; // eslint-disable-line
    ReactDOM.render(
      EntryComponent(NextApp),
      rootElement,
    );
  });
}



// WEBPACK FOOTER //
// ./src/index.js